import { render, staticRenderFns } from "./CustomerHubPackageCard.vue?vue&type=template&id=cf47dabe&scoped=true"
import script from "./CustomerHubPackageCard.vue?vue&type=script&lang=js"
export * from "./CustomerHubPackageCard.vue?vue&type=script&lang=js"
import style0 from "./CustomerHubPackageCard.vue?vue&type=style&index=0&id=cf47dabe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf47dabe",
  null
  
)

export default component.exports